/**
 * InboxHeader — back button + title + mark all read action.
 */

import React from 'react'
import { ArrowLeft, CheckCheck } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { triggerHapticImpact as hapticImpact } from '@turnifly/shared/utils'

interface InboxHeaderProps {
  onMarkAllRead?: () => void
  isMarkingRead?: boolean
}

export const InboxHeader: React.FC<InboxHeaderProps> = ({
  onMarkAllRead,
  isMarkingRead,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleBack = (): void => {
    hapticImpact('light')
    navigate(-1)
  }

  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-white/[0.06] tg-header-safe-area">
      <button
        onClick={handleBack}
        className="w-10 h-10 flex items-center justify-center rounded-full
          hover:bg-white/[0.04] transition-colors tap-highlight-transparent"
      >
        <ArrowLeft size={20} className="text-text" />
      </button>

      <h2 className="font-display font-bold text-lg text-text">
        {t('inbox.title')}
      </h2>

      {onMarkAllRead ? (
        <button
          onClick={() => {
            hapticImpact('light')
            onMarkAllRead()
          }}
          disabled={isMarkingRead}
          className="w-10 h-10 flex items-center justify-center rounded-full
            hover:bg-white/[0.04] transition-colors tap-highlight-transparent
            disabled:opacity-40"
        >
          <CheckCheck size={18} className="text-primary" />
        </button>
      ) : (
        <div className="w-10" />
      )}
    </div>
  )
}
